import { Model, ObservableList, RelationType as NeosRelationType, ViewModel, ViewModelState } from '@neos/core'
import CustomSubUIViewEntityViewParameterUI from '@src/views/CustomSubUIViewEntityViewParameterUI/CustomSubUIViewEntityViewParameterUI'
import CustomSubUIViewPropertyUI from '@src/views/CustomSubUIViewPropertyUI/CustomSubUIViewPropertyUI'
import CustomSubUIViewStyleRuleUI from '@src/views/CustomSubUIViewStyleRuleUI/CustomSubUIViewStyleRuleUI'
import { DataType } from '@neos/shared'

/**
 * Represents CustomSubUIViewUI.
 */
export default class CustomSubUIViewUI extends Model {
  /**
   * Initializes a new instance of the CustomSubUIViewUI class.
   * 
   * @param item Item.
   * @param viewModel ViewModel.
   */
  constructor(item?: Record<string, unknown>, viewModel?: ViewModel<CustomSubUIViewUI>) {
    super({
      $new: !item,
      id: 0,
      ...item
    }, viewModel)
  }

  /**
   * Gets or sets Created at.
   */
  createdAt?: Date | null

  /**
   * Gets or sets Created by.
   */
  createdBy?: string | null

  /**
   * Gets or sets Data groups.
   */
  dataGroups?: string | null

  /**
   * Gets or sets Data sorts.
   */
  dataSorts?: string | null

  /**
   * Gets or sets Sub UI view identifier.
   */
  id: number

  /**
   * Gets or sets OriginalOwnerViewModelState.
   */
  originalOwnerViewModelState: ViewModelState

  /**
   * Gets ownerViewModel.
   * 
   * @returns OwnerViewModel.
   */
  get ownerViewModel(): (ViewModel<Model> | null | undefined) {
    return this.$viewModel.getProperty('ownerViewModel').getValue(this) as (ViewModel<Model> | null | undefined)
  }

  /**
   * Gets or sets Parent collection name.
   */
  parentCollectionName?: string | null

  /**
   * Gets or sets Updated at.
   */
  updatedAt?: Date | null

  /**
   * Gets or sets Updated by.
   */
  updatedBy?: string | null

  /**
   * Gets or sets Parent Id.
   */
  parentId?: string

  /**
   * Gets or sets EntityViewParameterList.
   */
  entityViewParameterList: ObservableList<CustomSubUIViewEntityViewParameterUI>

  /**
   * Gets or sets PropertyList.
   */
  propertyList: ObservableList<CustomSubUIViewPropertyUI>

  /**
   * Gets or sets StyleRuleList.
   */
  styleRuleList: ObservableList<CustomSubUIViewStyleRuleUI>

  /**
   * Gets or sets $relations.
   */
  static $relations = new Map([['entityViewParameterList', { creator: CustomSubUIViewEntityViewParameterUI, type: NeosRelationType.collection, embeddedForReading: true, embeddedForWriting: true, autoLoad: true, associations: ['customSubUIViewId'], path: 'entityViewParameterList' }], ['propertyList', { creator: CustomSubUIViewPropertyUI, type: NeosRelationType.collection, embeddedForReading: true, embeddedForWriting: true, autoLoad: true, associations: ['customSubUIViewId'], path: 'propertyList' }], ['styleRuleList', { creator: CustomSubUIViewStyleRuleUI, type: NeosRelationType.collection, embeddedForReading: true, embeddedForWriting: true, autoLoad: true, associations: ['customSubUIViewId'], path: 'styleRuleList' }]])

  /**
   * Gets or sets $keyProperties.
   */
  static $keyProperties = new Set(['id'])

  /**
   * Gets or sets $unboundProperties.
   */
  static $unboundProperties = new Set(['originalOwnerViewModelState','ownerViewModel'])

  /**
   * Gets or sets $untrackedProperties.
   */
  static $untrackedProperties = new Set(['originalOwnerViewModelState','ownerViewModel'])

  /**
   * Gets or sets $properties.
   */
  static $properties = new Map([['createdAt', { dataType: DataType.dateTime, serverSideReadOnly: true, }], ['createdBy', { dataType: DataType.string, serverSideReadOnly: true, }], ['updatedAt', { dataType: DataType.dateTime, serverSideReadOnly: true, }], ['updatedBy', { dataType: DataType.string, serverSideReadOnly: true, }]])
}